module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../../node_modules/happypack/loader.js?id=jsx!./ProfitSharBindView.js"));
	}, "MyArchivesView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=MyArchivesView!./src/pages/Shop/Member/Personal/ProfitSharing/ProfitSharBind/ProfitSharBindView.js
// module id = 1924
// module chunks = 367